import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
import Rails from '@rails/ujs';
import YouTubePlayer from 'youtube-player';

export default class extends Controller {
  static targets = [ "output", "draggableList", "countDown", "ytplayer", "playlist"]

  initDraggableList(event){
    if (this.draggableListTarget.dataset.type == "steps") {
      let _this = this;

      $(this.draggableListTarget).sortable({
        update: function( event, ui ) {
          let ids = $(this).sortable('toArray');

          let _json = {new_order: ids, object_id: $(this).data("objectid"), type: $(this).data("objecttype")};
          
          fetch("/en/steps/reorder.js",
            {
              method: "post",
              body: JSON.stringify(_json),
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': Rails.csrfToken()
              },
              credentials: 'same-origin'
            }

          ).then(function (r) {location.reload();});

        }
      });
    }
  }

  submitSubscribeForm(event) {
    let email = $("input#subscriber_email").val();

    if (email.length > 0 && $("#subscribe-terms:checked").val() == 'true') {
      $.ajax({
        url: "https://auth.hundred.org/en/subscribe", 
        jsonp: "callback",
        dataType: "jsonp",
        data: {newsletter: true, subtype: "", email: email, service: "hundred", antibot: $("#subscribe-form .anti_field #name").val()},
        success: function( response ) {
          $("#subscribe-form").hide();
          $("#subscribe-thanks").removeClass("hidden")
        }
      });
    }
  }

  countDown(event) {
    let _this = this;

    if (_this.hasCountDownTarget) {
      let countDownDate = new Date(_this.countDownTarget.dataset.time).getTime();
      // Update the count down every 1 second
      let x = setInterval(function() {

        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        _this.countDownTarget.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          _this.countDownTarget.innerHTML = "EXPIRED";
        }
      }, 1000);
    }
  }

  ytPlaylist(event) {
    let _this = this;
    let player;
    let playlistId;


    if (_this.hasYtplayerTarget) {

      playlistId = _this.ytplayerTarget.dataset.id;
      console.log(playlistId);

      if (playlistId != undefined) {

        player = YouTubePlayer(_this.ytplayerTarget, {
          playerVars: {
            listType: 'playlist',
            list: playlistId,
          }
        });

        const pl = player.getPlaylist();
        
        pl.then((value) => {

          if (value && value.length > 0) {

            value.forEach((videoId, i) => {

              fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
                .then(res => res.json())
                .then((data) => {

                  const item = document.createElement('div');
                  item.className = 'item';
                  item.dataset.index = i;
                  item.innerHTML = `
                    <div class="thumb"><img loading="lazy" src="https://i.ytimg.com/vi/${videoId}/mqdefault.jpg" alt="thumb"></div>
                    <div class="info">
                    <div class="title">${data.title}</div>
                    </div>
                  `;
                  item.addEventListener('click', () => {
                  player.playVideoAt(i);
                  });

                  _this.playlistTarget.append(item);
                });

            });
          }
        });

      }

    }
  }


} 
